import React, { PropsWithChildren } from "react";
import { Form, Input } from "formik-antd";
import { Alert, Button } from "antd";
import { Formik, FormikHelpers } from "formik";
import * as Yup from "yup";

interface ILoginFormProps {
  isRequest: boolean;
  handleSubmit: (
    username: string,
    password: string,
    remember: boolean,
    setStatus: (status: string) => void
  ) => void;
}
interface IFormValues {
  email: string;
  password: string;
  remember: boolean;
}

const LoginForm: React.FC<ILoginFormProps> = (
  props: PropsWithChildren<ILoginFormProps>
): JSX.Element => {
  const { handleSubmit, isRequest } = props;
  const onSubmit = (
    values: IFormValues,
    actions: FormikHelpers<IFormValues>
  ) => {
    const { email, password, remember } = values;
    actions.setStatus(null);
    handleSubmit(email, password, remember, actions.setStatus);
  };

  const initialFormValues: IFormValues = {
    email: "",
    password: "",
    remember: false,
  };
  const UserCredentialSchema = Yup.object().shape({
    email: Yup.string()
      .email("Niepoprawny adres email")
      .required("Pole wymagane"),
    password: Yup.string().required("Pole wymagane"),
  });

  return (
    <Formik
      initialValues={initialFormValues}
      onSubmit={(values, actions) => {
        onSubmit(values, actions);
      }}
      validateOnChange
      validationSchema={UserCredentialSchema}
      render={({ status }) => (
        <Form
          layout="vertical"
          requiredMark={false}
          className="auth-login__form"
        >
          {status && (
            <Alert
              message={status}
              type="error"
              showIcon
              className="auth-login__error"
            />
          )}
          <Form.Item
            label="E-mail"
            name="email"
            rules={[{ required: true, message: "Wprowadź email!" }]}
          >
            <Input
              name="email"
              size="large"
              autoComplete="username"
              inputMode="email"
            />
          </Form.Item>

          <Form.Item
            label="Hasło"
            name="password"
            rules={[{ required: true, message: "Wprowadź hasło!" }]}
          >
            <Input.Password
              name="password"
              size="large"
              autoComplete="current-password"
            />
          </Form.Item>

          <Button
            type="primary"
            htmlType="submit"
            size="large"
            block
            loading={isRequest}
            className="auth-login__submit"
          >
            Zaloguj
          </Button>
        </Form>
      )}
    />
  );
};

export default LoginForm;
